module.exports = __webpack_public_path__ + "assets/meest_verkocht.df4c0fce.svg";